import _withSelectorProduction from "../cjs/use-sync-external-store-shim/with-selector.production.js";
export { _withSelectorProduction as default };
export const useSyncExternalStoreWithSelector = _withSelectorProduction.useSyncExternalStoreWithSelector;